module.exports = __webpack_public_path__ + "static/img/pic-5.3defa5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/pic-5.jpg
// module id = csNz
// module chunks = 1